import { useCallback, useState } from 'react'
import { CHANGELOG, LATEST_CHANGELOG_ID, type ChangelogEntry } from '@/lib/changelog'

const STORAGE_KEY = 'changelog-last-seen-id'

function readLastSeen(): number {
  if (typeof window === 'undefined') return LATEST_CHANGELOG_ID
  const raw = localStorage.getItem(STORAGE_KEY)
  const parsed = raw ? parseInt(raw, 10) : 0
  return Number.isNaN(parsed) ? 0 : parsed
}

/**
 * Tracks which changelog entries this device has seen (by entry id, in
 * localStorage). `hasUnseen` drives both the footer "What's new" dot and the
 * one-time announcement modal; `markSeen` clears it once the user has looked.
 */
export function useChangelog() {
  const [lastSeenId, setLastSeenId] = useState<number>(readLastSeen)

  const markSeen = useCallback(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, String(LATEST_CHANGELOG_ID))
    }
    setLastSeenId(LATEST_CHANGELOG_ID)
  }, [])

  const hasUnseen = LATEST_CHANGELOG_ID > lastSeenId
  const unseenEntries: ChangelogEntry[] = CHANGELOG.filter((e) => e.id > lastSeenId)

  return { entries: CHANGELOG, unseenEntries, hasUnseen, lastSeenId, markSeen }
}
